import { z } from 'zod';
/** Provider-agnostic staff row for AI availability read layer. */
export const availabilityStaffSchema = z
    .object({
    externalId: z.string().min(1).max(64),
    displayName: z.string().min(1).max(200),
})
    .strict();
/** Provider-agnostic slot row — UTC ISO start time only. */
export const availabilitySlotSchema = z
    .object({
    startAt: z.string().datetime(),
})
    .strict();
export const listAvailabilityStaffInputSchema = z
    .object({
    bookingProvider: z.string().min(1).max(32),
    locationId: z.string().min(1).max(64),
    serviceExternalId: z.string().min(1).max(64),
})
    .strict();
export const listAvailabilitySlotsInputSchema = z
    .object({
    bookingProvider: z.string().min(1).max(32),
    locationId: z.string().min(1).max(64),
    serviceExternalId: z.string().min(1).max(64),
    staffExternalId: z.string().min(1).max(64),
    date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
})
    .strict();
export const listAvailabilityDatesInputSchema = z
    .object({
    bookingProvider: z.string().min(1).max(32),
    locationId: z.string().min(1).max(64),
    serviceExternalId: z.string().min(1).max(64),
    staffExternalId: z.string().min(1).max(64),
})
    .strict();
//# sourceMappingURL=availability-platform.js.map